<template>
  <div class="AboutActivity clearfix">
    <h2>活动特惠</h2>
    <div class="container loading-area">
      <ul>
        <li v-for="(item, index) in tableAbout" :key="index">
          <router-link :to="'/aboutdesign/details/' + item.id">
            {{ item.title }}
            <em>{{ item.createTime}}</em>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { reqActivity } from '../../api/'
import PubSub from 'pubsub-js'
import MapLoader from '../../js/AMap.js'
import Cookies from 'js-cookie'
import AMapUI from 'AMapUI'

export default {
  name: 'AboutActivity',
  data () {
    return {
      position: Cookies.get('position') || 2,
      tableAbout: [],
      total: 0,
      pages: 1, //当前页
      page_count: '',
      pageSize: 10 //一页展示多少
    }
  },
  created(){
    const currentPage = this.pages
    const pageSize = this.pageSize
    // console.log('currentPage:',currentPage , 'pageSize:',pageSize)
    reqActivity(currentPage, pageSize, this.position).then(res=>{
      if (!res.data.errno) {
        res.data.list.sort((a,b) => {
          return b.id - a.id
        })
        res.data.list.forEach( val => {
          if (val.activityType == 1) {
            this.tableAbout.push(val)
          }
        })
        this.total = res.data.total
        this.page_count = res.data.navigatepageNums.length+1
        console.log('tableAbout', this.tableAbout)
      }
    })
  },
  methods: {
  },
  mounted () {
  },
  components: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../css-styl/mixins.styl'

  .AboutActivity
    h2
      font-size 24px
      font-weight 600
      padding 20px 14px 14px
      border-bottom 1px solid #e4e4e4
    .container
      width 100%
      margin 40px auto
      ul
        li
          height 40px
          line-height 40px
          border-bottom 1px solid #e4e4e4
          a
            margin-left 36px
            transition 0.2s all
            -webkit-transition 0.2s all
            -moz-transition 0.2s all
            -o-transition 0.2s all
            -ms-transition 0.2s all
            &:hover,
            &:focus
              color #d81240
            em
              float right
              font-style normal
              margin-right 36px
</style>



// WEBPACK FOOTER //
// src/pages/aboutpages/AboutActivity.vue